webpackJsonp([9,7],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(22);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(127);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _vueRouter = __webpack_require__(94);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _routers = __webpack_require__(124);
	
	var _routers2 = _interopRequireDefault(_routers);
	
	var _vueResource = __webpack_require__(75);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _vueInfiniteScroll = __webpack_require__(144);
	
	var _vueInfiniteScroll2 = _interopRequireDefault(_vueInfiniteScroll);
	
	var _vueLazyload = __webpack_require__(61);
	
	var _vueLazyload2 = _interopRequireDefault(_vueLazyload);
	
	var _store3 = __webpack_require__(44);
	
	__webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueInfiniteScroll2.default);
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueResource2.default);
	_vue2.default.use(_vueLazyload2.default, {
	  error: __webpack_require__(59),
	  loading: __webpack_require__(60),
	  attempt: 1
	});
	var router = new _vueRouter2.default({
	  'linkActiveClass': 'active',
	  routes: _routers2.default });
	
	var routerApp = new _vue2.default({
	  store: _store2.default,
	  router: router
	}).$mount('#app');
	
	if (!(0, _store3.loadFromlLocal)('gank', 'wecome', false)) {
	  router.push('/wecome');
	}
	exports.default = routerApp;

/***/ },

/***/ 44:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(141);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	exports.savaToLocal = savaToLocal;
	exports.loadFromlLocal = loadFromlLocal;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function savaToLocal(id, key, value) {
	  var seller = window.localStorage.__seller__;
	  if (!seller) {
	    seller = {};
	    seller[id] = {};
	  } else {
	    seller = JSON.parse(seller);
	    if (!seller[id]) {
	      seller[id] = {};
	    }
	  }
	  seller[id][key] = value;
	  window.localStorage.__seller__ = (0, _stringify2.default)(seller);
	}
	function loadFromlLocal(id, key, def) {
	  var seller = window.localStorage.__seller__;
	  if (!seller) {
	    return def;
	  }
	  seller = JSON.parse(seller)[id];
	  if (!seller) {
	    return def;
	  }
	  var ret = seller[key];
	  return ret || def;
	}

/***/ },

/***/ 59:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/404.7b6469c.png";

/***/ },

/***/ 60:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/loading.091be57.gif";

/***/ },

/***/ 73:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 123:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var NAME_TITILE = exports.NAME_TITILE = ['welfare', 'day', 'android', 'ios', 'web'];

/***/ },

/***/ 124:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var routers = [{
	  path: '/',
	  name: 'index',
	  component: function component(resolve) {
	    __webpack_require__.e/* nsure */(0, function () {
	      resolve(__webpack_require__(31));
	    });
	  },
	
	  children: [{
	    path: '/welfare',
	    name: 'welfare',
	    component: function component(resolve) {
	      __webpack_require__.e/* nsure */(2, function () {
	        resolve(__webpack_require__(38));
	      });
	    }
	  }, {
	    path: '/day',
	    name: 'day',
	    component: function component(resolve) {
	      __webpack_require__.e/* nsure */(1, function () {
	        resolve(__webpack_require__(36));
	      });
	    },
	
	    meta: { requiresAuth: true }
	  }, {
	    path: '/ios',
	    name: 'ios',
	    component: function component(resolve) {
	      __webpack_require__.e/* nsure */(4, function () {
	        resolve(__webpack_require__(33));
	      });
	    },
	
	    meta: { requiresAuth: true }
	  }, {
	    path: '/android',
	    name: 'android',
	    component: function component(resolve) {
	      __webpack_require__.e/* nsure */(3, function () {
	        resolve(__webpack_require__(32));
	      });
	    }
	  }, {
	    path: '/web',
	    name: 'web',
	    component: function component(resolve) {
	      __webpack_require__.e/* nsure */(5, function () {
	        resolve(__webpack_require__(34));
	      });
	    }
	  }]
	}, {
	  path: '/wecome',
	  name: 'wecome',
	  component: function component(resolve) {
	    __webpack_require__.e/* nsure */(6, function () {
	      resolve(__webpack_require__(37));
	    });
	  }
	}];
	
	exports.default = routers;

/***/ },

/***/ 125:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var incrementCounter = exports.incrementCounter = function incrementCounter(_ref) {
	  var dispatch = _ref.dispatch,
	      state = _ref.state;
	};

/***/ },

/***/ 126:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getHeaderTitle = getHeaderTitle;
	function getHeaderTitle(state) {
	  return state.headerTitle;
	};

/***/ },

/***/ 127:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(22);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(14);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _actions = __webpack_require__(125);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _getters = __webpack_require__(126);
	
	var getters = _interopRequireWildcard(_getters);
	
	var _uz = __webpack_require__(123);
	
	var uz = _interopRequireWildcard(_uz);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var state = {
	  'headerTitle': '福利',
	  'menus': uz.NAME_TITILE,
	  'menuShow': false,
	  'loadingShow': false,
	  'news': 5
	};
	
	var mutations = {
	  UPDATE_TITLE: function UPDATE_TITLE(state, title) {
	    console.log(title);
	    state.headerTitle = title;
	  },
	  UPDATE_MENUSHOW: function UPDATE_MENUSHOW(state) {
	    state.menuShow = !state.menuShow;
	  },
	  UPDATE_LOADING: function UPDATE_LOADING(state, data) {
	    state.loadingShow = data;
	  },
	  UPDATE_NEWS: function UPDATE_NEWS(state) {
	    state.news = 0;
	  }
	};
	
	exports.default = new _vuex2.default.Store({
	  state: state,
	  mutations: mutations,
	  actions: actions,
	  getters: getters
	});

/***/ }

});


// WEBPACK FOOTER //
// static/js/app.e181ebe9cb4394468390.js